module.exports = __webpack_public_path__ + "static/media/tb_app_icon_remove_user.376edb36.svg";